import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemIconComponentModule } from '../../atoms/icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-stat-card',
  templateUrl: './stat-card.component.html',
  styleUrl: './stat-card.component.scss',
})
export class StatCardComponent {
  @Input() iconName?: string;
  @Input() iconType: 'solid' | 'outline' = 'solid';
  @Input() iconSize = 24;
  @Input() iconBgColor = 'bg-gray-100';

  @Input() title = '';
  @Input() subtitle = '';

  @Input() titleSize: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg' | 'text-xl' | 'text-2xl' | 'text-3xl' = 'text-xl';
  @Input() subtitleSize: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg' | 'text-xl' = 'text-base';

  @Input() titleFont = 'font-bold';
  @Input() subtitleFont = 'font-normal';

  get iconContainerClasses(): string {
    return `flex items-center justify-center w-10 h-10 ${this.iconBgColor} rounded-lg`;
  }
}

@NgModule({
  declarations: [StatCardComponent],
  imports: [CommonModule, SystemIconComponentModule, TranslateModule],
  exports: [StatCardComponent],
})
export class StatCardModule {}
